import React from 'react';
import AdminPg from './adminPage';
import './admin.scss';

function adminPage() {  
  return (
    <div className="App">
      <AdminPg />
    </div>
  );
}

export default adminPage;